/*
 * Dates as days — '2026-09-28' — the way the server sends them. Worked at midday so a change of the
 * clocks can never tip one into the day before or after.
 */

export function todayKey(now: Date = new Date()): string {
  return keyOf(now);
}

export function keyOf(when: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${when.getFullYear()}-${pad(when.getMonth() + 1)}-${pad(when.getDate())}`;
}

export function dayOf(key: string): Date {
  return new Date(`${key}T12:00:00`);
}

export function addDays(key: string, days: number): string {
  const when = dayOf(key);
  when.setDate(when.getDate() + days);
  return keyOf(when);
}

/* Mon 28 Sep */
export function shortDay(key: string): string {
  return dayOf(key).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
}

/* Monday 28 September */
export function longDay(key: string): string {
  return dayOf(key).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' });
}

/* 28 Sep, 14:05 — for a moment something was done, rather than a day */
export function moment(value: string | null): string {
  if (!value) return '';
  return new Date(value).toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}
